import axiosInstance from "./axiosConfig";

const API_URL = process.env.REACT_APP_API_URL;

// Obtener un rol por ID
export const getRoleById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/role/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.message);
    }
};

// Obtener roles por companyId
export const getRolesByCompanyId = async (companyId) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/roles/${companyId}`);
        return response;
    } catch (error) {
        throw new Error(error.message);
    }
};

// Crear un nuevo rol
export const createRole = async (role) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/role`, role);
        return response.data;
    } catch (error) {
        throw new Error(error.message);
    }
};

// Actualizar un rol existente
export const updateRole = async (id, role) => {
    try {
        role.id = id;
        const response = await axiosInstance.post(`${API_URL}/role`, role);
        return response.data;
    } catch (error) {
        throw new Error(error.message);
    }
};

// Eliminar un rol por ID
export const deleteRole = async (id) => {
    try {
        const response = await axiosInstance.delete(`${API_URL}/role/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.message);
    }
};
